import clsx from 'classnames'
import * as React from 'react'

interface PickerToolbarProps {
  isLandscape: boolean
  className?: string
  children: React.ReactNode
}

const PickerToolbar = ({ children, isLandscape, className, ...other }: PickerToolbarProps) => {
  return (
    <div
      className={clsx('MuiPickersToolbar-toolbar', { 'MuiPickersToolbar-toolbarLandscape': isLandscape }, className)}
      {...other}
    >
      {children}
    </div>
  )
}

export default PickerToolbar
